<template>
  <div class="app-container">
    <div class="app-content ">
      <el-card class="import-manager" shadow="never">
        <template #header>
          <el-form :model="searchForm" inline size="small">
            <el-form-item :label="$t('text.sblx')">
              <el-input
                v-model="searchForm.gatewaysn"
                clearable
              />
            </el-form-item>
            <el-form-item :label="$t('text.jyzt')">
              <el-select v-model="searchForm.valflag" clearable>
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="$t(item.label)"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                class="search-btn"
                style="background:#175E77;border:none"
                @click="search"
              >{{ $t('button.cx') }}</el-button>
              <el-button
                icon="el-icon-check"
                style="background:#CB925D;border:none"
                type="success"
                @click="handleCommit"
              >{{ $t('button.tj') }}</el-button>
              <el-button type="text" icon="el-icon-download" @click="downloadTemplate">{{ $t('button.xzmb') }}</el-button>
            </el-form-item>
          </el-form>
        </template>

        <template #default>
          <el-card shadow="never">
            <template #header>
              <el-button size="mini" icon="el-icon-upload2" type="primary" @click="handleSingleImport">{{ $t('button.dgdr') }}</el-button>
              <el-upload
                ref="upload"
                action=""
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :on-exceed="handleExceed"
                :limit="1"
                :auto-upload="false"
                :file-list="fileList"
                style="margin-left: 10px"
              >
                <el-button size="mini" icon="el-icon-upload" type="primary">{{ $t('button.pldr') }}</el-button>
              </el-upload>
              <el-button size="mini" icon="el-icon-refresh" type="warning" style="margin-left: 10px" @click="createGuid">{{ $t('button.ggpch') }}</el-button>
              <el-button size="mini" icon="el-icon-delete" type="danger" @click="batchDelete">{{ $t('button.plsc') }}</el-button>
            </template>
            <template #default>
              <el-table
                v-loading="listLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.7)"
                height="calc(100% - 50px)"
                style="width: 100%"
                :data="list"
                @selection-change="handleSelectionChange"
              >
                <template slot="empty">
                  <div class="table-no-data" />
                </template>
                <el-table-column type="index" width="50" :label="$t('text.xh')" align="center" />
                <el-table-column type="selection" width="50" align="center" />
                <el-table-column :label="$t('text.sbxlh')" align="center">
                  <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                      <el-input
                        v-model="scope.row.gatewaysn"
                        class="edit-input"
                        size="small"
                      />
                    </template>
                    <span v-else>{{ scope.row.gatewaysn }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('text.sim')" align="center">
                  <template slot-scope="scope">
                    <template v-if="scope.row.edit && scope.row.commtype !== '0'">
                      <el-input
                        v-model="scope.row.sim"
                        class="edit-input"
                        size="small"
                      />
                    </template>
                    <span v-else>{{ scope.row.sim | nullFilter }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('text.bm')" align="center">
                  <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                      <el-input
                        v-model="scope.row.alias"
                        class="edit-input"
                        size="small"
                      />
                    </template>
                    <span v-else>{{ scope.row.alias | nullFilter }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('text.sblx')" align="center">
                  <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                      <el-select v-model="scope.row.gtype">
                        <el-option :label="$t('text.zc')" value="0" />
                        <el-option :label="$t('text.cn')" value="1" />
                        <el-option :label="$t('text.qx')" value="2" />
                        <el-option :label="$t('text.db')" value="3" />
                      </el-select>
                    </template>
                    <span v-else>{{ scope.row.gtype | gtypeFilter }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('text.txlx')" align="center">
                  <template v-slot="scope">
                    <span>{{ scope.row.commtype | netFilter }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('text.jy')" align="center">
                  <template slot-scope="scope">
                    <span :class="scope.row.valflag === '0' ? 'success' : 'error'">{{ scope.row.valflag === '0' ? $t('text.cg') : $t('text.sbai') }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('text.ms')" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.valdesc ? scope.row.valdesc : '--' }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('text.drsj')" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.createtime }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('text.cz')" width="180" align="center">
                  <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                      <el-tooltip
                        :key="scope.row.id"
                        :content="$t('notice.qr')"
                        effect="dark"
                        placement="left"
                      >
                        <el-button
                          type="success"
                          size="small"
                          @click.native.prevent="confirmEdit(scope.row)"
                        >
                          <i class="el-icon-check" />
                        </el-button>
                      </el-tooltip>
                      <el-tooltip
                        effect="dark"
                        placement="right"
                        :content="$t('notice.qx')"
                      >
                        <el-button
                          type="warning"
                          size="small"
                          @click.native.prevent="cancelEdit(scope.row)"
                        >
                          <i class="el-icon-close" />
                        </el-button>
                      </el-tooltip>
                    </template>
                    <template v-else>
                      <el-button
                        type="text"
                        size="small"
                        icon="el-icon-edit"
                        @click.native.prevent="scope.row.edit=!scope.row.edit"
                      >{{ $t('button.bj') }}</el-button>
                    </template>
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination
                v-show="total > 0"
                background
                layout="total, prev, pager, next"
                small
                :total="total"
                :current-page.sync="page"
                :page-size.sync="limit"
                @current-change="getList"
              />
            </template>
          </el-card>
        </template>
      </el-card>

      <!-- 单个导入弹出框 -->
      <el-dialog
        :title="$t('sider.sbdr')"
        :visible.sync="importDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <el-form :model="deviceForm" label-width="160px">
          <el-form-item :label="$t('text.sbxlh')">
            <el-input
              v-model.trim="deviceForm.gatewaysn"
              autocomplete="off"
              :placeholder="$t('placeholder.sbxlh')"
            />
          </el-form-item>
          <el-form-item :label="$t('text.txlx')">
            <el-select
              v-model="deviceForm.commtype"
              autocomplete="off"
              clearable
            >
              <el-option label="WIFI" value="0" />
              <el-option label="2G" value="1" />
              <el-option label="3G" value="2" />
              <el-option label="4G" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.sblx')">
            <el-select v-model="deviceForm.gtype">
              <el-option :label="$t('text.zc')" value="0" />
              <el-option :label="$t('text.cn')" value="1" />
              <el-option :label="$t('text.qx')" value="2" />
              <el-option :label="$t('text.db')" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item v-show="deviceForm.commtype!== '0'" :label="$t('text.sim')">
            <el-input
              v-model.trim="deviceForm.sim"
              autocomplete="off"
              :placeholder="$t('placeholder.sim')"
            />
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="importSingle"
          >{{ $t('button.qd') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ImportGateways, SingleImportGateways, QueryTempData, CommitToDb, UpdateImp,
  BatchDeleteImp
} from '@apis/Device'
import { QueryDistributor } from '@apis/Users'
import { guid } from '@utils'
export default {
  data () {
    return {
      listLoading: false,
      guid: '',
      fileTemp: null,
      fileList: [],
      list: [],
      importDialog: false,
      options: [
        {
          label: 'text.qb',
          value: ''
        },
        {
          label: 'text.jycg',
          value: '1'
        },
        {
          label: 'text.jysb',
          value: '0'
        }
      ],
      deviceForm: {
        batchid: '',
        commtype: '',
        gtype: '',
        gatewaysn: '',
        sim: ''
      },
      searchForm: {
        batchid: '',
        gatewaysn: ''
      },
      limit: 10,
      total: 0,
      page: 1,
      pageForm: {
        batchid: '',
        gatewaysn: ''
      },
      disOptions: [],
      multipleSelection: []
    }
  },
  computed: {
    // 去除guid的'-'
    guidFilter () {
      return this.guid.split('-').join('')
    }
  },
  created () {
    this.getDistriList()
    this.guid = guid()
  },
  methods: {
    // 获取表格选中项
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 查询
    search () {
      this.page = 1
      this.searchForm.batchid = this.guidFilter
      this.pageForm = this.$deepClone(this.searchForm)
      this.getDataForShort(this.searchForm)
    },
    // 生成新的guid
    createGuid () {
      this.$confirm(this.$t('notice.gxpch'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        type: 'warning'
      }).then(() => {
        this.guid = guid()
        this.$message({
          type: 'success',
          message: this.$t('notice.gxcg'),
          duration: 1 * 1000
        })
        this.search()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('notice.qxgx'),
          duration: 1 * 1000
        })
      })
    },
    // 单个导入按钮
    handleSingleImport () {
      this.importDialog = true
      this.deviceForm = {
        batchid: '',
        commtype: '',
        gtype: '',
        gatewaysn: '',
        sim: ''
      }
    },
    // 导入文件成功时触发
    handleChange (file) {
      this.fileTemp = file.raw
      if (this.fileTemp) {
        if ((this.fileTemp.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
          (this.fileTemp.type === 'application/vnd.ms-excel')) {
          this.importfile(this.fileTemp)
        } else {
          this.$message({
            type: 'warning',
            message: this.$t('notice.cxsc'),
            duration: 1 * 1000
          })
        }
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('notice.scfj'),
          duration: 1 * 1000
        })
      }
    },
    // 下载模板
    downloadTemplate () {
      const downlaodUrl = `${process.env.VUE_APP_BASE_API}files/template/储能数据.xlsx`
      window.location.href = downlaodUrl
    },
    // 导入文件移除时触发
    handleRemove () {
      this.fileTemp = null
    },
    // 导入1个以上文件时触发
    handleExceed () {
      this.$message({
        type: 'error',
        message: this.$t('notice.znscyg'),
        duration: 1 * 1000
      })
    },
    // 导入文件
    importfile (obj) {
      var reader = new FileReader()
      reader.readAsDataURL(obj)
      reader.onload = () => {
        ImportGateways({ batchid: this.guidFilter, base64: reader.result, distributor: '' }).then(() => {
          this.searchForm.batchid = this.guidFilter
          this.pageForm.batchid = this.guidFilter
          this.getDataForShort(this.searchForm)
        })
      }
    },
    // 单个导入
    importSingle () {
      this.deviceForm.batchid = this.guidFilter
      if (this.deviceForm.commtype === '0') {
        this.deviceForm.sim = ''
      }
      SingleImportGateways(this.deviceForm)
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$t('notice.drcg'),
            duration: 1 * 1000
          })
          this.searchForm.batchid = this.guidFilter
          this.pageForm.batchid = this.guidFilter
          this.importDialog = false
          this.getDataForShort(this.searchForm)
        })
    },
    // 获取临时表
    getDataForShort (condition) {
      this.listLoading = true
      QueryTempData({
        page: this.page,
        perPage: this.limit,
        orderBy: 'gatewaysn',
        whereCondition: JSON.stringify(condition)
      }).then(res => {
        if (res.data.queryResults) {
          this.list = res.data.queryResults.map(v => {
            this.$set(v, 'edit', false)
            v.old = this.$deepClone(v)
            return v
          })
        } else {
          this.list = []
        }

        this.total = res.data.totalCount
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    // 分页pagination组件事件
    getList () {
      this.getDataForShort(this.pageForm)
    },
    // 确认按钮
    confirmEdit (row) {
      UpdateImp({
        batchid: this.guidFilter,
        id: row.id,
        alias: row.alias,
        sim: row.sim,
        gtype: row.gtype,
        gatewaysn: row.gatewaysn
      }).then(() => {
        row.edit = false
        this.$message({
          message: this.$t('notice.xgcg'),
          type: 'success'
        })
        this.getDataForShort(this.searchForm)
      })
    },
    // 取消按钮
    cancelEdit (row) {
      // console.log(row)
      Object.keys(row.old).forEach(function (key) {
        row[key] = row.old[key]
      })
      row.edit = false
    },
    // 批量删除
    batchDelete () {
      const ids = this.multipleSelection.map(o => {
        return o.id
      })
      if (ids.length) {
        this.$confirm(this.$t('notice.yjsc'), this.$t('notice.title'), {
          confirmButtonText: this.$t('button.qr'),
          cancelButtonText: this.$t('button.qx'),
          type: 'warning'
        }).then(() => {
          BatchDeleteImp({
            ids: ids,
            tag: this.guidFilter
          }).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('notice.sccg'),
              duration: 1 * 1000
            })
            this.getDataForShort(this.searchForm)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('notice.qxsc'),
            duration: 1 * 1000
          })
        })
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('notice.zsyg'),
          duration: 1 * 1000
        })
      }
    },
    // 提交
    handleCommit () {
      CommitToDb({
        id: this.guidFilter
      }).then(() => {
        this.$refs.upload.clearFiles()
        this.$message({
          type: 'success',
          message: this.$t('notice.tjcg'),
          duration: 1 * 1000
        })
        this.guid = guid()
        this.search()
      })
    },
    // 获取分销商列表
    getDistriList () {
      QueryDistributor({
        id: ''
      })
        .then(res => {
          this.disOptions = res.data
        })
    }
  }
}
</script>
<style scoped>
.import-manager{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #1d3666;
  border-color: #1d3666;
}
.import-manager >>>.el-card__header{
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
}
.import-manager >>>.el-card__header .el-form{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.import-manager >>>.el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.import-manager >>>.el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px 0;
  box-sizing: border-box;
}
.import-manager >>>.el-card__body .el-card{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #1d3666;
  border-color: #1d3666;
}
.import-manager >>>.el-card__body .el-card .el-card__header{
  width: 100%;
  height: 40px;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.import-manager >>>.el-card__body .el-card .el-card__body{
  width: 100%;
  height: calc(100% - 40px);
  padding: 0;
  box-sizing: border-box;
}

.import-manager >>>.el-card__body .el-card .el-card__body .el-table{
  width: 100%;
  height: calc(100% - 50px);
  box-sizing: border-box;
  background-color: #1C2550;
}
.import-manager >>>.el-card__body .el-card .el-card__body .el-table .el-table__header{
  table-layout: auto;
}
.import-manager >>>.el-card__body .el-card .el-card__body .el-checkbox.is-checked .el-checkbox__inner{
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.import-manager >>>.el-card__body .el-card .el-card__body .el-pagination{
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

</style>
